// CommonView.js

import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";

import Calendar from "../components/calendar";

import Dropdown from "bootstrap/js/dist/dropdown";

let CommonView = Backbone.View.extend({
    el: "#content",

    eventsFilters: {},

    events: {
        'keyup [type="text"][data-custom-donation-input]': "integerValue",

        "click [data-donate-amount]": "toggleActive",
        "click [data-membership]": "toggleActive",

        // pagination
        "click .pagination a": "_loadMoreClickHandler",

        // calendar toggle
        "click .filters-search-toggle": "_calendarToggleHandler",

        "click .content-block--whatson .filter-options .btn-tag":
            "_filtersCatToggleHandler",
        "click .listing-section .dropdown-menu a":
            "_listingSectionFilterHandler",

        // Shop
        "click .dropdown-sort .dropdown-item": "_shopSortHandler",

        // Timeline
        "click .decades .btn-tag": "_decadesNavigationHandler",

        // Footer form
        "click .footer-form input" : "_open_footer_form",

        // Spektrix Memberships
        'change .memberships-upsale .memberships .memberships-check input[type="radio"]': 'toggleMembershipButton',
    },

    toggleMembershipButton: function (e) {
        const $radio = $(e.currentTarget);
        const selectedId = $radio.val();
    
        // Scope only to the current .memberships block
        const $upsaleBlock = $radio.closest('.memberships');
    
        // Hide all spektrix buttons inside this block
        $upsaleBlock.find('spektrix-memberships').each(function () {
            const $membership = $(this);
            if ($membership.attr('data-membership-id') === selectedId) {
                $membership.show();
            } else {
                $membership.hide();
            }
        });
    },

    _open_footer_form: function (e) {
        $('.footer-form .gfield').show()

        console.log(e, 'here show')
    },

    _decadesNavigationHandler(e) {
        e.preventDefault();

        const $a = $(e.currentTarget),
            year = $a.attr("data-year");

        const destination = $(
            `.year-entry-section[data-decade=${year}]`
        ).first();

        if (destination.length) {
            $("html, body").animate(
                {
                    scrollTop: $(destination).offset().top,
                },
                300
            );
        }

        return false;
    },

    _shopSortHandler(e) {
        e.preventDefault();

        let $a = $(e.currentTarget),
            href = $a.attr("href");

        var dropdown = new Dropdown(document.getElementById("dropdown-sort"));

        // Check if the URL already has a query string
        var separator = href.includes('?') ? '&' : '?';

        // Append the new query string accordingly
        $.get(href + separator + "ajax=1", (html) => {
            // console.log(html)
            $("#shop-listing").html($(html).find("#shop-listing").html());
        });

        return false;
    },

    _listingSectionFilterHandler(e) {
        e.preventDefault();

        let $a = $(e.currentTarget),
            term = $a.data("slug"),
            $container = $a.closest(".listing-section"),
            model = $container.data("model");

        let url = "";

        if ("resource" == model) {
            url =
                ajax_client.baseurl +
                "/join-in-section-overview/learning-resources" +
                (term ? "/res-category/" + term : "");
        }

        if ("pressrelease" == model) {
            url = $a.attr("href");
        }

        url += "?ajax=1";

        // $('.dropdown-menu', $container[0]).dropdown('toggle')

        const dropdownToggleEl = document.getElementById(
            "dropdown-menu-" + model
        );
        const dropdownList = new Dropdown(dropdownToggleEl);
        dropdownList.hide();

        $("." + model + "s-list").html("Loading...");

        $.get(url, (html) => {
            $container.html($(html).find(".listing-section").html());
        });

        return false;
    },

    _filtersCatToggleHandler(e) {
        e.preventDefault();

        let $a = $(e.currentTarget),
            _this = this;

        // $('.content-block--whatson .filter-options .btn-tag').removeClass('active')

        $a.toggleClass("active");

        // let cat = $a.data('category')

        let cats = [];
        let access_cats = [];

        $(".content-block--whatson .filter-options .btn-tag.category").each(
            (index, el) => {
                let $el = $(el);
                if ($el.hasClass("active")) {
                    cats.push($el.data("category"));
                }
            }
        );

        $(
            ".content-block--whatson .filter-options .btn-tag.access-category"
        ).each((index, el) => {
            let $el = $(el);
            if ($el.hasClass("active")) {
                access_cats.push($el.data("category"));
            }
        });

        // if ( cat && cat != _this.eventsFilters.cat ) {
        if (cats.length) {
            _this.eventsFilters.cat = cats;
        } else {
            delete _this.eventsFilters["cat"];
            // $a.removeClass('active')
        }

        if (access_cats.length) {
            _this.eventsFilters.access_cat = access_cats;
        } else {
            delete _this.eventsFilters["access_cat"];
            // $a.removeClass('active')
        }

        _this.reloadEvents("#events-listing");

        return false;
    },

    _calendarToggleHandler(e) {
        e.preventDefault();

        $(e.currentTarget)
            .closest(".content-block")
            .toggleClass("ui-calendar-on");

        if (!$(e.currentTarget).has(".content-block")) {
            delete _this.eventsFilters["events"];
            delete _this.eventsFilters["date"];
            _this.reloadEvents("#events-listing");
        }

        return false;
    },

    initialize: function () {
        var _this = this;

        Backbone.history.start({ pushState: true });

        // Show only the default (first) selected membership buttons
        $('.memberships').each(function () {
            const $block = $(this);
            const $checked = $block.find('input[type="radio"]:checked');
            const selectedId = $checked.val();

            $block.find('spektrix-memberships').each(function () {
                const $membership = $(this);
                if ($membership.attr('data-membership-id') === selectedId) {
                    $membership.show();
                } else {
                    $membership.hide();
                }
            });
        });
        // $(window).on('resize', _.debounce(function(e) {
        //     _this.resize(e)
        // }, 100))
    },

    _loadMoreClickHandler(e) {
        e.preventDefault();

        const _this = this;
        const $a = $(e.currentTarget);

        let wrapper_selector = $a.attr("data-wrapper"),
            wrapper = $(wrapper_selector),
            model = wrapper.attr("data-model"),
            next_page = $a.attr("data-next-page"),
            href = $a.attr("href");

        _this.loadNextPage(wrapper, model, next_page, href);

        return false;
    },

    loadNextPage(wrapper, model, next_page, href) {
        console.log("loadNextPage::", [wrapper, model, next_page, href]);

        $.ajax({
            url: href,
            data: {
                ajax: 1,
                next_page: next_page,
            },
            success: (result) => {
                $(".row", wrapper)
                    .last()
                    .append($(result).find(".listing-loader .row").html());

                if ($(result).find(".pagination").length) {
                    $(".pagination", wrapper).html(
                        $(result).find(".pagination").html()
                    );
                } else {
                    $(".pagination", wrapper).hide();
                }
            },
        });
    },

    toggleActive: function (e) {
        var el = $(e.currentTarget);

        $(".active", el.parent()).removeClass("active");
        el.toggleClass("active");

        // console.log(el)

        if (el.attr("data-membership") && el.attr("data-membership").length) {
            // alert(el.attr('data-membership'))
            // console.log(el)
            // console.log(el.attr('data-membership'))
            $(".spektrix-membership").removeClass("active");
            $("#spektrix-membership-" + el.attr("data-membership")).addClass(
                "active"
            );
        }
    },

    integerValue: function (e) {
        $("[data-donate-amount].active").removeClass("active");

        var el = $(e.currentTarget);
        var val = el.val();

        el.val(val.replace(/[^0-9.]/, ""));
    },

    // resize: function(){
    //   this.responsive()
    // },

    render: function () {
        $("a.blank").attr("target", "_blank");

        $(window).triggerHandler("resize");

        // this.cookies()
        // this.responsive()
        // this.popovers()
        // this.tooltips()

        // let modal_view = new ModalView()
        // let tabs_view = new TabsView()

        this.whatsonlisting();

        // $('.access-lang-nav-mobile-row .topbar-nav--language').html($('.topbar .topbar-nav--language').html())

        if ($("#product-gallery-big").length) {
            this.shopGallery();
        }
    },

    whatsonlisting() {
        var _this = this;
        $("#events-listing").on("items-reloaded", function (e, r) {
            // console.log("items-reloaded::", r.date, r.items, r.response);

            _this.eventsFilters.date = r.date;
            _this.eventsFilters.events = r.items; //$.extend({}, r.items)

            if ($("#events-filters-accessibility").length) {
                _this.eventsFilters["accessibility"] = 1;
            } else {
                _this.eventsFilters["accessibility"] = false;
            }

            _this.reloadEvents("#events-listing");

            return false;
        });
    },

    reloadEvents: function (container) {
        var _this = this;
        // console.log('f:::', filters)

        if ($("#events-filters-accessibility").length) {
            _this.eventsFilters["accessibility"] = 1;
        } else {
            _this.eventsFilters["accessibility"] = false;
        }

        // let container = '#events-listing'
        console.log("eventsFilters::", _this.eventsFilters);
        $.ajax({
            url: ajax_client.ajax_url,
            dataType: "html",
            cache: false,
            type: "get",
            // processData: false,
            data: {
                action: "filter_events",
                ajax: true,
                filters: _this.eventsFilters,
                // {
                //     date: _this.eventsFilters.date ? _this.eventsFilters.date : false,
                //     events: _this.eventsFilters.items ? _this.eventsFilters.events : false,
                //     cat: _this.eventsFilters.cat ? _this.eventsFilters.cat : false,
                // }
            },
            success: function (result) {
                // alert($(result).find(container).html())
                $(container).html($(result).find(container).html());

                if (
                    _this.eventsFilters.date ||
                    _this.eventsFilters.events ||
                    _this.eventsFilters.cat
                ) {
                    $("#content").addClass("ui-filters-on");
                } else {
                    $("#content").removeClass("ui-filters-on");
                }

                Backbone.history.navigate(
                    ajax_client.current_url.replace(ajax_client.baseurl, "") +
                        (_this.eventsFilters.cat ||
                        _this.eventsFilters.access_cat
                            ? "?"
                            : "") +
                        (_this.eventsFilters.cat
                            ? "&cat=" + _this.eventsFilters.cat
                            : "") +
                        (_this.eventsFilters.access_cat
                            ? "&access-cat=" + _this.eventsFilters.access_cat
                            : ""),
                    false
                );
            },
        });

        return false;
    },

    shopGallery() {
        var bigimage = $("#product-gallery-big");
        var thumbs = $("#product-thumbs");
        //var totalslides = 10
        var syncedSecondary = true;

        bigimage
            .owlCarousel({
                items: 1,
                slideSpeed: 2000,
                nav: false,
                autoplay: false,
                dots: false,
                loop: true,
                responsiveRefreshRate: 200,
                navText: [
                    '<span class="icon-left icon-chevron-large-left" aria-label="Previous Image"></span>',
                    '<span class="icon-right icon-chevron-large-right" aria-label="Next Image"></span>',
                ],
            })
            .on("changed.owl.carousel", syncPosition);

        thumbs
            .on("initialized.owl.carousel", function () {
                thumbs.find(".owl-item").eq(0).addClass("current");
            })
            .owlCarousel({
                items: 5,
                dots: true,
                nav: true,
                navText: [
                    '<span class="icon-left icon-chevron-left" aria-label="Previous Image"></span>',
                    '<span class="icon-right icon-chevron-right" aria-label="Next Image"></span>',
                ],
                smartSpeed: 200,
                slideSpeed: 500,
                slideBy: 5,
                responsiveRefreshRate: 100,
            })
            .on("changed.owl.carousel", syncPosition2);

        function syncPosition(el) {
            //if loop is set to false, then you have to uncomment the next line
            //var current = el.item.index;

            //to disable loop, comment this block
            var count = el.item.count - 1;
            var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

            if (current < 0) {
                current = count;
            }

            if (current > count) {
                current = 0;
            }

            //to this
            thumbs
                .find(".owl-item")
                .removeClass("current")
                .eq(current)
                .addClass("current");

            var onscreen = thumbs.find(".owl-item.active").length - 1;
            var start = thumbs.find(".owl-item.active").first().index();
            var end = thumbs.find(".owl-item.active").last().index();

            if (current > end) {
                thumbs.data("owl.carousel").to(current, 100, true);
            }

            if (current < start) {
                thumbs.data("owl.carousel").to(current - onscreen, 100, true);
            }
        }

        function syncPosition2(el) {
            if (syncedSecondary) {
                var number = el.item.index;
                bigimage.data("owl.carousel").to(number, 100, true);
            }
        }

        thumbs.on("click", ".owl-item", (e) => {
            e.preventDefault();
            let number = $(this).index();
            bigimage.data("owl.carousel").to(number, 300, true);
        });
    },
});

export default CommonView;
